module.exports = {
	"listPeerings": "/api/cps/peerConn/queryPeerConnPage",
	"peeringStatus": "/api/cps/peerConn/queryPeerConnStatus",
};



// WEBPACK FOOTER //
// ./src/api/peering/list/config.js